import { render, staticRenderFns } from "./ApplyTheme.vue?vue&type=template&id=485c7204&scoped=true&"
import script from "./ApplyTheme.vue?vue&type=script&lang=js&"
export * from "./ApplyTheme.vue?vue&type=script&lang=js&"
import style0 from "./ApplyTheme.vue?vue&type=style&index=0&id=485c7204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485c7204",
  null
  
)

export default component.exports